
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { WindowRef } from 'src/windowRef.server';
import { filter, map } from "rxjs/operators";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ononTig';
  today = new Date();
  constructor(private windowRef: WindowRef, private router: Router, private activatedRoute: ActivatedRoute, private titleService: Title) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let child = this.activatedRoute.firstChild;
        while (child) {
          if (child.firstChild) {
            child = child.firstChild;
          } else if (child.snapshot.data && child.snapshot.data['title']) {
            return child.snapshot.data['title'];
          } else {
            return null;
          }
        }
        return null;
      })
    ).subscribe((data: any) => {
      if (data) {
        this.titleService.setTitle( '蒙古文字体下载-蒙古文字体设计-Onon字体网-' + data);
      }
    });
  }
  Position() {
    this.windowRef.nativeWindow.open('https://map.baidu.com/poi/%E9%93%B6%E9%83%BD%E5%A4%A7%E5%8E%A6B%E5%BA%A7/@12432295.273168432,4956389.391592342,19.18z?uid=be1ea5efa7834cbf14948e14&info_merge=1&isBizPoi=false&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&querytype=detailConInfo&da_src=shareurl');
  }
}
